import React, { Component } from "react";
import FormGroup from "@material-ui/core/FormGroup";
import Tooltip from "@material-ui/core/Tooltip";
import Typography from "@material-ui/core/Typography";
import Paper from "@material-ui/core/Paper";
import Divider from "@material-ui/core/Divider";
import Button from "@material-ui/core/Button";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import ArrowDropDown from "@material-ui/icons/ArrowDropDown";
import ArrowDropUp from "@material-ui/icons/ArrowDropUp";
import IconButton from "@material-ui/core/IconButton";
import TextField from "@material-ui/core/TextField";
import FormControl from "@material-ui/core/FormControl";
import NativeSelect from "@material-ui/core/NativeSelect";
import Input from "@material-ui/core/Input";
import { withStyles } from "@material-ui/core/styles";
import { withTranslation } from "react-i18next";
import { getErrorString } from "../display/ErrorStrings";
import PopupMessage from "../components/PopupMessage";
import ViewCheckPopup from "../components/ViewCheckPopup";
import ReactImageMagnify from "react-image-magnify";

import RevalidateIcon from "@material-ui/icons/RefreshOutlined";
import ReturnIcon from "@material-ui/icons/CloseOutlined";
import PayIcon from "@material-ui/icons/CheckOutlined";
import QuitScrubIcon from "@material-ui/icons/VisibilityOffOutlined";
import DeselectIcon from "@material-ui/icons/BackspaceOutlined";
import ZoomIcon from "@material-ui/icons/ZoomInOutlined";
import ViewBackIcon from "@material-ui/icons/YoutubeSearchedForOutlined";

import { AmountFormatCustom } from "../components/AmountFormatCustom";

const styles = (theme) => ({
  root: {
    width: "100%",
    marginTop: theme.spacing.unit * 3,
  },
});

class SuspectItemDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      imageError: "",
      validationError: "",
      actionError: "",
      imageZoom: false,
      backImagePopup: false,
      errorString: "",
      notifyString: "",
      item: {},
      itemsLeft: 0,
      detailedItem: {},
      canView: false,
      viewPopup: false,
      dispositioned: false,
      historyData: [],
      historyErrorString: "",
      collapsedHistory: true,
      checkNumber: "",
      amount: "",
      payee: "",
      returnCode: "000",
      comment: "",
      authCode: "",
      currentTransit: "",
      currentAccount: "",
      type: "",
    };
    this.onClose = this.onClose.bind(this);
  }

  componentDidMount() {
    if (this.props.scrub) {
      this.scrubSearch();
    } else {
      this.setState({ item: this.props.item });
      this.searchDetailedItem(this.props.item);
    }
  }

  handleCheckNumber(e) {
    this.setState({ checkNumber: e.target.value });
  }

  handleAmount(e) {
    this.setState({ amount: e.target.value });
  }

  handlePayee(e) {
    this.setState({ payee: e.target.value });
  }

  handleReturnCode(e) {
    this.setState({ returnCode: e.target.value });
  }

  handleComments(e) {
    this.setState({ comment: e.target.value });
  }

  handleAuthCode(e) {
    this.setState({ authCode: e.target.value });
  }

  onClose(e) {
    e.preventDefault();
    if (
      this.state.imageError.length !== 0 ||
      this.state.validationError.length !== 0 ||
      this.state.actionError.length !== 0 ||
      this.state.imageZoom ||
      this.state.backImagePopup
    ) {
      this.setState({ imageError: "" });
      this.setState({ validationError: "" });
      this.setState({ actionError: "" });
      this.setState({ viewPopup: false });
      this.setState({ imageZoom: false });
      this.setState({ backImagePopup: false });
    } else {
      if (this.state.dispositioned && !this.props.fromHome) {
        this.props.onDisposition(e);
      } else {
        if (this.props.scrub) {
          fetch("on_release_scrub_item", {
            method: "POST",
            credentials: "same-origin",
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              item: this.state.item,
              secureToken: this.props.secureToken,
            }),
          })
            .then(function (res) {
              if (!res.ok) {
                throw Error(res.status + " (" + res.statusText + ")");
              }
              return res;
            })
            .then((res) => res.text())
            .then((text) => {
              var reply = JSON.parse(text);
              if (!reply.authenticated) {
                this.props.history.push("/expired");
              } else if (reply.error) {
                this.setState({ errorString: reply.errorString });
                this.setState({ viewPopup: true });
              }
            })
            .catch((error) => {
              this.setState({
                errorString:
                  getErrorString(
                    "general.server.status.error",
                    "The server responded with a status of "
                  ) + error.message,
              });
              this.setState({ viewPopup: true });
            });
        }
        this.props.onClosePopup(e);
      }
    }
  }

  keepItem(item) {
    fetch("on_keep_scrub_item", {
      method: "POST",
      credentials: "same-origin",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        item: item,
        secureToken: this.props.secureToken,
      }),
    })
      .then(function (res) {
        if (!res.ok) {
          throw Error(res.status + " (" + res.statusText + ")");
        }
        return res;
      })
      .then((res) => res.text())
      .then((text) => {
        var reply = JSON.parse(text);
        if (!reply.authenticated) {
          this.props.history.push("/expired");
        } else if (reply.error) {
          this.setState({ errorString: reply.errorString });
          this.setState({ viewPopup: true });
        }
      })
      .catch((error) => {
        this.setState({
          errorString:
            getErrorString(
              "general.server.status.error",
              "The server responded with a status of "
            ) + error.message,
        });
      });
  }

  onPay(e) {
    if (this.props.viewOnly) {
      this.setState({
        errorString: getErrorString(
          "viewOnly.warning",
          "Operation not allowed in support mode."
        ),
      });
      this.setState({ viewPopup: true });
      return;
    }
    if (!this.validateInput(false)) {
      return;
    }
    this.disposition(true);
  }

  onReturn(e) {
    if (this.props.viewOnly) {
      this.setState({
        errorString: getErrorString(
          "viewOnly.warning",
          "Operation not allowed in support mode."
        ),
      });
      this.setState({ viewPopup: true });
      return;
    }
    if (this.state.item.status !== "P1" && this.state.item.status !== "P2") {
      if (
        this.state.returnCode === "000" ||
        this.state.returnCode.length === 0
      ) {
        this.setState({
          validationError: getErrorString(
            "disposition.reason.error",
            "Return Reason is required."
          ),
        });
        this.setState({ viewPopup: true });
        return;
      }
    }
    this.disposition(false);
  }

  onRevalidate(e) {
    if (this.props.viewOnly) {
      this.setState({
        errorString: getErrorString(
          "viewOnly.warning",
          "Operation not allowed in support mode."
        ),
      });
      this.setState({ viewPopup: true });
      return;
    }
    if (!this.validateInput(this.state.detailedItem.eccRequired)) {
      return;
    }
    fetch("on_revalidate_request", {
      method: "POST",
      credentials: "same-origin",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        transit: this.state.currentTransit,
        account: this.state.currentAccount,
        pay: true,
        checkNumber: this.state.checkNumber,
        amount: this.state.amount,
        payee: this.state.payee,
        ecc: this.state.authCode,
        returnReason: this.state.returnCode,
        comment: this.state.comment,
        item: this.state.item,
        secureToken: this.props.secureToken,
      }),
    })
      .then(function (res) {
        if (!res.ok) {
          throw Error(res.status + " (" + res.statusText + ")");
        }
        return res;
      })
      .then((res) => res.text())
      .then((text) => {
        var reply = JSON.parse(text);
        if (!reply.authenticated) {
          this.props.history.push("/expired");
        } else if (reply.error) {
          this.setState({ actionError: reply.errorString });
          this.setState({ viewPopup: true });
        } else {
          this.setState({ dispositioned: false });
          if (reply.pay) {
            this.setState({ dispositioned: true });
            if (this.props.scrub && this.state.itemsLeft !== 0) {
              this.scrubSearch();
            } else {
              this.props.onDisposition(null);
            }
          } else if (reply.reasonRejected.length !== 0) {
            let updatedItem = this.state.item;
            updatedItem.reasonRejected = reply.reasonRejected;
            this.setState({ item: updatedItem });
          }
        }
      })
      .catch((error) => {
        this.setState({
          actionError:
            getErrorString(
              "general.server.status.error",
              "The server responded with a status of "
            ) + error.message,
        });
        this.setState({ viewPopup: true });
      });
  }

  handleCollapse = (event) => {
    this.setState({ collapsedHistory: !this.state.collapsedHistory });
  };

  handleZoom(e) {
    this.setState({ imageZoom: true });
  }

  handleBackImage(e) {
    let myUrl = this.getUrl("on_check_image_request", this.state.item);
    //myUrl += '&back=yes';
    fetch(myUrl, {
      method: "POST",
      credentials: "same-origin",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        r: new Date().getTime(),
        secureToken: this.props.secureToken,
        transit: this.state.currentTransit,
        account: this.state.currentAccount,
        checkNumber: this.state.item.checkNumber,
        trace: this.state.item.trace,
        date: this.state.item.date,
        amount: this.state.item.rowAmount,
        back: "yes",
      }),
    })
      .then(function (res) {
        if (!res.ok) {
          throw Error(res.status + " (" + res.statusText + ")");
        }
        return res;
      })
      .then((res) => res.text())
      .then((text) => {
        var reply = JSON.parse(text);
        if (reply.authenticated === false) {
          this.props.history.push("/expired");
        } else {
          if (reply.error) {
            this.setState({ imageError: reply.errorString });
            this.setState({ viewPopup: true });
          } else {
            this.setState({ backImagePopup: true });
          }
        }
      })
      .catch((error) => {
        this.setState({
          imageError:
            getErrorString(
              "general.server.status.error",
              "The server responded with a status of "
            ) + error.message,
        });
        this.setState({ viewPopup: true });
      });
  }

  validateInput(authCodeRequired) {
    if (this.state.checkNumber.length === 0) {
      this.setState({
        validationError: getErrorString(
          "stopPayment.checkNumber.error",
          "Check Number is required."
        ),
      });
      this.setState({ viewPopup: true });
      return false;
    }
    if (this.state.amount.length === 0) {
      this.setState({
        validationError: getErrorString(
          "stopPayment.amount.error",
          "Amount is required."
        ),
      });
      this.setState({ viewPopup: true });
      return false;
    }
    /*if (this.state.payee.length === 0) {
      this.setState({
        validationError: getErrorString(
          "disposition.payee.error",
          "Payee is required."
        ),
      });
      this.setState({ viewPopup: true });
      return false;
    }*/
    if (authCodeRequired && this.state.authCode.length === 0) {
      this.setState({
        validationError: getErrorString(
          "revalidation.authCode.error",
          "Authentication Code is required."
        ),
      });
      this.setState({ viewPopup: true });
      return false;
    }
    return true;
  }

  disposition(actionPay) {
    fetch("on_disposition_request", {
      method: "POST",
      credentials: "same-origin",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        transit: this.state.currentTransit,
        account: this.state.currentAccount,
        pay: actionPay,
        checkNumber: this.state.checkNumber,
        amount: this.state.amount,
        payee: this.state.payee,
        ecc: this.state.authCode,
        returnReason: this.state.returnCode,
        comment: this.state.comment,
        item: this.state.item,
        secureToken: this.props.secureToken,
      }),
    })
      .then(function (res) {
        if (!res.ok) {
          throw Error(res.status + " (" + res.statusText + ")");
        }
        return res;
      })
      .then((res) => res.text())
      .then((text) => {
        var reply = JSON.parse(text);
        if (!reply.authenticated) {
          this.props.history.push("/expired");
        } else if (reply.error) {
          this.setState({ actionError: reply.errorString });
          this.setState({ viewPopup: true });
        } else {
          if (this.props.scrub) {
            if ((this.state.itemsLeft !== 0) || (this.state.itemsLeft == 0)) {
               this.setState({ dispositioned: true });
               this.scrubSearch();
            } else {
               this.props.onDisposition(null);
            }
          } else {
            this.props.onDisposition(null);
          }
        }
      })
      .catch((error) => {
        this.setState({
          actionError:
            getErrorString(
              "general.server.status.error",
              "The server responded with a status of "
            ) + error.message,
        });
        this.setState({ viewPopup: true });
      });
  }

  scrubSearch() {
    let myUrl = this.props.url;
    let transit;
    let account;
    if (this.props.fromHome) {
      transit = "";
      account = "";
    } else {
      transit = this.props.accountObject.transit;
      account = this.props.accountObject.account;
    }
    fetch(myUrl, {
      method: "POST",
      credentials: "same-origin",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        r: new Date().getTime(),
        secureToken: this.props.secureToken,
        transit: transit,
        account: account,
        scrub: "yes",
        page: 0,
        rowsPerPage: 10,
      }),
    })
      .then(function (res) {
        if (!res.ok) {
          throw Error(res.status + " (" + res.statusText + ")");
        }
        return res;
      })
      .then((res) => res.text())
      .then((text) => {
        var reply = JSON.parse(text);
        if (reply.authenticated === false) {
          this.props.history.push("/expired");
        } else {
          if (reply.error) {
            this.setState({ errorString: reply.errorString });
            this.setState({ viewPopup: true });
          } else if (reply.warning) {
            this.setState({ notifyString: reply.warningString });
            this.setState({ warning: true });
            this.setState({ viewPopup: true });
          } else {
            let newItems = reply.items;
            if (reply.numItems === 0) {
              this.setState({ viewPopup: true });
              this.setState({
                notifyString: getErrorString(
                  "general.info.search.empty",
                  "Total number of scrub items is 0."
                ),
              });
            } else {
              let numLeft = reply.numLeft;
              if (numLeft < 0) {
                numLeft = 0;
              }
              this.setState({ itemsLeft: numLeft });
              this.setState({ item: newItems[0] });
              this.searchDetailedItem(newItems[0]);
              this.keepItem(newItems[0]);
            }
          }
        }
      })
      .catch((error) => {
        this.setState({
          errorString:
            getErrorString(
              "general.server.status.error",
              "The server responded with a status of "
            ) + error.message,
        });
        this.setState({ viewPopup: true });
      });
  }

  searchDetailedItem(myItem) {
    this.setState({ canView: false });
    let transit;
    let account;
    if (this.props.fromHome) {
      transit = myItem.transit;
      account = myItem.account;
    } else {
      transit = this.props.accountObject.transit;
      account = this.props.accountObject.account;
    }
    this.setState({ currentTransit: transit });
    this.setState({ currentAccount: account });

    fetch("on_suspect_details_request", {
      method: "POST",
      credentials: "same-origin",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        transit: transit,
        account: account,
        item: myItem,
        secureToken: this.props.secureToken,
      }),
    })
      .then(function (res) {
        if (!res.ok) {
          throw Error(res.status + " (" + res.statusText + ")");
        }
        return res;
      })
      .then((res) => res.text())
      .then((text) => {
        var reply = JSON.parse(text);
        if (!reply.authenticated) {
          this.props.history.push("/expired");
        } else if (reply.error) {
          this.setState({ errorString: reply.errorString });
          this.setState({ viewPopup: true });
        } else if (reply.warning) {
          this.setState({ notifyString: reply.warningString });
          this.setState({ warning: true });
          this.setState({ viewPopup: true });
        } else {
          this.setState({ detailedItem: reply.item });
          if (reply.item.canDisposition) {
            let detItem = reply.item;
            this.setState({ type: detItem.validType });
            this.setState({ checkNumber: myItem.checkNumber });
            this.setState({ amount: myItem.rowAmount });
            this.setState({ payee: myItem.payee });
            this.setState({ comment: detItem.notes });
            this.setState({ authCode: detItem.ecc });
            if (!this.props.scrub && detItem.retCode !== "") {
              this.setState({ returnCode: detItem.retCode });
            } else {
              this.setState({ returnCode: "000" });
            }
            this.setState({ canView: true });
            this.loadHistory(myItem, transit, account);
          } else {
            this.setState({
              notifyString: "You cannot disposition items at this time.",
            });
            this.setState({ viewPopup: true });
          }
        }
      })
      .catch((error) => {
        this.setState({
          errorString:
            getErrorString(
              "general.server.status.error",
              "The server responded with a status of "
            ) + error.message,
        });
        this.setState({ viewPopup: true });
      });
  }

  loadHistory(item, transit, account) {
    fetch(this.getUrl("on_item_history_request", item), {
      method: "POST",
      credentials: "same-origin",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        r: new Date().getTime(),
        secureToken: this.props.secureToken,
        transit: transit,
        account: account,
        checkNumber: this.state.item.checkNumber,
        trace: this.state.item.trace,
        date: this.state.item.date,
        amount: this.state.item.rowAmount,
      }),
    })
      .then(function (res) {
        if (!res.ok) {
          throw Error(res.status + " (" + res.statusText + ")");
        }
        return res;
      })
      .then((res) => res.text())
      .then((text) => {
        var reply = JSON.parse(text);
        if (reply.authenticated === false) {
          this.props.history.push("/expired");
        } else {
          if (reply.error) {
            this.setState({ historyErrorString: reply.errorString });
          } else {
            this.setState({ historyData: reply.history });
          }
        }
      })
      .catch((error) => {
        this.setState({
          historyErrorString:
            getErrorString(
              "general.server.status.error",
              "The server responded with a status of "
            ) + error.message,
        });
      });
  }

  getUrl(requestType, item) {
    return requestType;
  }

  render() {
    let { t } = this.props;
    let data = this.state.historyData;
    let reason = this.state.item.reasonRejected;
    let type = this.state.type;
    let imgUrl =
      "img/src" +
      new Date().getTime() +
      ".png";
    return (
      <div style={{ marginTop: this.props.fromHome ? 20 : 0 }}>
        {this.state.viewPopup && this.state.imageError.length > 0 && (
          <PopupMessage
            title={getErrorString("general.error", "Error")}
            text={this.state.imageError}
            error={true}
            onClosePopup={this.onClose}
          />
        )}
        {this.state.viewPopup && this.state.actionError.length > 0 && (
          <PopupMessage
            title={getErrorString("general.error", "Error")}
            text={this.state.actionError}
            error={true}
            onClosePopup={this.onClose}
          />
        )}

        {this.state.viewPopup && this.state.validationError.length > 0 && (
          <PopupMessage
            title={getErrorString("general.error", "Error")}
            text={this.state.validationError}
            error={true}
            onClosePopup={this.onClose}
          />
        )}
        {this.state.viewPopup && this.state.errorString.length > 0 && (
          <PopupMessage
            title={getErrorString("general.error", "Error")}
            text={this.state.errorString}
            error={true}
            onClosePopup={this.onClose}
          />
        )}
        {this.state.viewPopup && this.state.notifyString.length > 0 && (
          <PopupMessage
            title={getErrorString("general.info.title", "Information")}
            text={this.state.notifyString}
            error={false}
            onClosePopup={this.onClose}
          />
        )}
        {this.state.imageZoom && (
          <ViewCheckPopup
            zoom={true}
            regular={false}
            onClosePopup={this.onClose}
            url={
              "img/src" +
              new Date().getTime() +
              ".png"
            }
          />
        )}
        {this.state.backImagePopup && (
          <ViewCheckPopup
            zoom={true}
            regular={false}
            onClosePopup={this.onClose}
            url={
              "img/back" +
              new Date().getTime() +
              ".png"
            }
          />
        )}

        {this.state.canView && (
          <div>
            <Paper elevation={5}>
              <FormGroup row>
                <Typography variant="headline" color="primary">
                  &nbsp;&nbsp;{" "}
                  {this.props.scrub
                    ? t("scrubItem.label")
                    : t("suspectedItem.label")}
                  &nbsp;&nbsp; &nbsp;&nbsp;
                </Typography>
                <Button onClick={this.onClose} color="primary">
                  {this.props.scrub && <QuitScrubIcon />}
                  {!this.props.scrub && <DeselectIcon />}
                  {this.props.scrub
                    ? t("quitScrub.button")
                    : t("deselect1.button")}
                </Button>
                &nbsp;
                {this.state.detailedItem.canDisposition &&
                  this.state.detailedItem.revState < 5 &&
                  this.state.item.status !== "P1" &&
                  this.state.item.status !== "P2" &&
                  !this.props.uiExclusionsList.includes("REVALIDATE") && (
                    <Button
                      onClick={(event) => this.onRevalidate(event)}
                      color="primary"
                    >
                      <RevalidateIcon />
                      &nbsp;{t("revalidate.button")}
                    </Button>
                  )}
                &nbsp;
                {this.state.detailedItem.canDisposition &&
                  this.state.detailedItem.revState < 5 &&
                  this.state.item.status !== "P1" &&
                  this.state.item.status !== "P2" && (
                    <Button
                      onClick={(event) => this.onPay(event)}
                      color="primary"
                    >
                      <PayIcon />
                      &nbsp;{t("pay.label")}
                    </Button>
                  )}
                {this.state.detailedItem.canDisposition &&
                  this.state.detailedItem.revState < 5 &&
                  this.state.item.status === "P1" && (
                    <Button
                      onClick={(event) => this.onPay(event)}
                      color="primary"
                    >
                      <PayIcon />
                      &nbsp;{t("approvePay.button")}
                    </Button>
                  )}
                {this.state.detailedItem.canDisposition &&
                  this.state.detailedItem.revState < 5 &&
                  this.state.item.status === "P2" && (
                    <Button
                      onClick={(event) => this.onPay(event)}
                      color="primary"
                    >
                      <PayIcon />
                      &nbsp;{t("approveReturn.button")}
                    </Button>
                  )}
                &nbsp;
                {this.state.detailedItem.canDisposition &&
                  this.state.detailedItem.revState < 5 &&
                  this.state.item.status !== "P1" &&
                  this.state.item.status !== "P2" && (
                    <Button
                      onClick={(event) => this.onReturn(event)}
                      color="primary"
                    >
                      <ReturnIcon />
                      &nbsp;{t("return.label")}
                    </Button>
                  )}
                &nbsp;
                {this.state.detailedItem.canDisposition &&
                  this.state.detailedItem.revState < 5 &&
                  this.state.item.status !== "P1" &&
                  this.state.item.status !== "P2" && (
                    <div>
                      &nbsp;&nbsp;
                      <Typography variant="caption">
                        {t("returnReason.label")}&nbsp;&nbsp;
                      </Typography>
                      <FormControl>
                        <NativeSelect
                          style={{
                            height: 27,
                            verticalAlign: "textTop",
                            margin: 0,
                          }}
                          defaultValue={this.state.returnCode}
                          input={<Input id="return_code" />}
                          onChange={(event) => this.handleReturnCode(event)}
                        >
                          {this.props.returnCodes.map((n) => {
                            return (
                              <option value={n.id}>{n.description}</option>
                            );
                          })}
                        </NativeSelect>
                      </FormControl>
                      &nbsp;&nbsp;
                    </div>
                  )}
                {this.state.detailedItem.canDisposition &&
                  this.state.detailedItem.revState < 5 &&
                  this.state.item.status === "P1" && (
                    <Button
                      onClick={(event) => this.onReturn(event)}
                      color="primary"
                    >
                      <ReturnIcon />
                      &nbsp;{t("denyPay.button")}
                    </Button>
                  )}
                {this.state.detailedItem.canDisposition &&
                  this.state.detailedItem.revState < 5 &&
                  this.state.item.status === "P2" && (
                    <Button
                      onClick={(event) => this.onReturn(event)}
                      color="primary"
                    >
                      <ReturnIcon />
                      &nbsp;{t("denyReturn.button")}
                    </Button>
                  )}
              </FormGroup>
              <Divider />
            </Paper>
            <Typography variant="body1" color="error">
              {this.state.detailedItem.lockName.length > 0 &&
                this.state.detailedItem.lockName !==
                  this.state.detailedItem.userName &&
                !this.state.detailedItem.canDisposition && (
                  <p>
                    &nbsp;&nbsp;<strong> {t("itemLocked.label")}</strong>{" "}
                    {this.state.detailedItem.lockName}{" "}
                  </p>
                )}
              {this.state.detailedItem.lockName.length > 0 &&
                this.state.detailedItem.lockName ===
                  this.state.detailedItem.userName &&
                !this.state.detailedItem.canDisposition && (
                  <p>
                    &nbsp;&nbsp;
                    <strong> {t("itemPendingSameUser.label")}</strong>
                    {" ("}
                    {this.state.detailedItem.lockName}
                    {") "}
                  </p>
                )}
              {this.state.detailedItem.lockName.length > 0 &&
                this.state.detailedItem.lockName !==
                  this.state.detailedItem.userName &&
                this.state.detailedItem.canDisposition && (
                  <p>
                    &nbsp;&nbsp;<strong> {t("itemReviewed.label")}</strong>{" "}
                    {this.state.detailedItem.lockName}{" "}
                  </p>
                )}
              {this.state.detailedItem.canDisposition && (
                <p>
                  &nbsp;&nbsp;{t("youHave.label")}{" "}
                  <strong>{this.state.detailedItem.minutesLeft}</strong>{" "}
                  {t("minutesLeft.label")}
                  {this.props.scrub && (
                    <span>
                      &nbsp;&nbsp;&nbsp;&nbsp;{t("itemLeft.label")}{" "}
                      <strong>{this.state.itemsLeft} </strong>
                    </span>
                  )}
                </p>
              )}
            </Typography>
            <FormGroup row>
              <p> &nbsp;&nbsp;{t("checkImage.label")}&nbsp;&nbsp;</p>
              <Tooltip title={t("zoom.tip")}>
                <Button
                  color="primary"
                  onClick={(event) => this.handleZoom(event)}
                >
                  <ZoomIcon />
                  &nbsp;{t("zoom.button")}
                </Button>
              </Tooltip>
              <Tooltip title={t("viewBack.tip")}>
                <Button
                  color="primary"
                  onClick={(event) => this.handleBackImage(event)}
                >
                  <ViewBackIcon />
                  &nbsp;{t("viewBack.button")}
                </Button>
              </Tooltip>
            </FormGroup>
            <ReactImageMagnify
              {...{
                smallImage: {
                  alt: "Not Available",
                  width: 768,
                  height: 328,
                  src: imgUrl,
                },
                largeImage: {
                  src: imgUrl,
                  width: 2304,
                  height: 981,
                },
              }}
            />

            <Paper elevation={5}>
              {this.props.fromHome && (
                <p>
                  &nbsp;&nbsp;<strong>{t("transit.label")}</strong>{" "}
                  {this.state.currentTransit} &nbsp;{" "}
                  <strong>{t("account.label")}</strong>{" "}
                  {this.state.currentAccount}&nbsp;&nbsp;
                </p>
              )}
              <p>
                &nbsp;&nbsp;<strong>{t("trace.header")}:</strong>{" "}
                {this.state.item.trace} &nbsp;
                <strong>{t("reasonRejected.header")}:</strong>{" "}
                <italic style={{ color: "red" }}>
                  {" "}
                  {this.state.item.reasonRejected}
                </italic>{" "}
                &nbsp;&nbsp;
                <strong>{t("defaultClosingDecision.label")}:</strong>{" "}
                <strong style={{ color: "red" }}>
                  {this.state.detailedItem.defaultClosing === "R"
                    ? "Return"
                    : this.state.detailedItem.defaultClosing === "P"
                    ? "Pay"
                    : this.state.detailedItem.defaultClosing}
                </strong>
              </p>
              <p>
                &nbsp;&nbsp;
                <strong>{t("issueAmount.label")}:</strong>{" "}
                {this.state.detailedItem.issueAmount}&nbsp;
                <strong>{t("issuePayee.label")}:</strong>{" "}
                {this.state.detailedItem.iPayee}
              </p>

              {!this.state.detailedItem.canDisposition && (
                <div>
                  <p>
                    {" "}
                    &nbsp;&nbsp;<strong>{t("checkNumber.label")}:</strong>{" "}
                    {this.state.item.checkNumber} &nbsp;
                    <strong>{t("amount.label")}:</strong>{" "}
                    {this.state.item.amount}&nbsp;
                    <strong>{t("payee.label")}:</strong> {this.state.item.payee}
                  </p>
                  <p>
                    {" "}
                    &nbsp;&nbsp;<strong>{t("comments.label")}:</strong>
                    {this.state.detailedItem.notes}
                  </p>
                </div>
              )}
              {this.state.detailedItem.canDisposition && (
                <div>
                  <FormGroup row>
                    &nbsp;&nbsp;
                    <TextField
                      style={{ width: "15%" }}
                      margin="dense"
                      id="checkNumber"
                      label={t("checkNumber.label")}
                      type="text"
                      disabled={this.props.uiExclusionsList.includes(
                        "REVALIDATE"
                      )}
                      required
                      defaultValue={this.state.checkNumber}
                      onChange={(event) => this.handleCheckNumber(event)}
                      onKeyPress={(event) => {
                        return event.charCode >= 48 && event.charCode <= 57
                          ? true
                          : event.preventDefault();
                      }}
                    />
                    &nbsp;&nbsp;
                    <TextField
                      style={{ width: "15%" }}
                      margin="dense"
                      id="amount"
                      label={t("amount.label")}
                      type="text"
                      disabled={this.props.uiExclusionsList.includes(
                        "REVALIDATE"
                      )}
                      required
                      defaultValue={this.state.amount}
                      onChange={(event) => this.handleAmount(event)}
                      InputProps={{
                        inputComponent: AmountFormatCustom,
                      }}
                      InputLabelProps={{ shrink: true }}
                    />
                    &nbsp;&nbsp;
                    {reason.indexOf("ACH") < 0 &&
                      type.indexOf("POSPAY") < 0 &&
                      type.indexOf("RPP") < 0 && (
                        <Tooltip title={this.state.payee}>
                          <TextField
                            style={{ width: "40%" }}
                            margin="dense"
                            id="payee"
                            label={t("payee.label")}
                            disabled={this.props.uiExclusionsList.includes(
                              "REVALIDATE"
                            )}
                            //required
                            defaultValue={this.state.payee}
                            onChange={(event) => this.handlePayee(event)}
                          />
                        </Tooltip>
                      )}
                    &nbsp;&nbsp;
                    {reason.indexOf("ACH") < 0 &&
                      this.state.detailedItem.eccRequired &&
                      type.indexOf("PPP") < 0 && (
                        <TextField
                          style={{ width: "15%" }}
                          margin="dense"
                          id="auth_code"
                          label={t("authenticationCode.label")}
                          disabled={this.props.uiExclusionsList.includes(
                            "REVALIDATE"
                          )}
                          required
                          defaultValue={this.state.authCode}
                          onChange={(event) => this.handleAuthCode(event)}
                        />
                      )}
                    &nbsp;&nbsp;
                    <Tooltip title={this.state.comment}>
                      <TextField
                        style={{ width: "15%" }}
                        margin="dense"
                        id="comment"
                        label={t("comments.label")}
                        defaultValue={this.state.comment}
                        onChange={(event) => this.handleComments(event)}
                      />
                    </Tooltip>
                  </FormGroup>

                  <br />
                </div>
              )}
              <Divider />
              <br />
            </Paper>

            <FormGroup row>
              <p> &nbsp;&nbsp;{t("history.label")}&nbsp;&nbsp;</p>
              {!this.state.collapsedHistory && (
                <Tooltip title={t("collapsHistory.tip")}>
                  <IconButton onClick={(event) => this.handleCollapse(event)}>
                    <ArrowDropUp />
                  </IconButton>
                </Tooltip>
              )}
              {this.state.collapsedHistory && (
                <Tooltip title={t("expandHistory.tip")}>
                  <IconButton onClick={(event) => this.handleCollapse(event)}>
                    <ArrowDropDown />
                  </IconButton>
                </Tooltip>
              )}
            </FormGroup>

            {this.state.historyErrorString.length > 0 &&
              !this.state.collapsedHistory && (
                <h3 style={{ color: "red" }}>
                  {" "}
                  {this.state.historyErrorString}{" "}
                </h3>
              )}
            {this.state.historyErrorString.length === 0 &&
              !this.state.collapsedHistory && (
                <Paper elevation={5}>
                  <List dense={false}>
                    {data.map((n) => {
                      return (
                        <ListItem>
                          <ListItemText primary={n} secondary={null} />
                        </ListItem>
                      );
                    })}
                  </List>
                </Paper>
              )}
          </div>
        )}
      </div>
    );
  }
}

export default withTranslation()(withStyles(styles)(SuspectItemDetails));
